import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PrimaryContactEntityEffects } from './primary-contact.effects';
import {
  PrimaryContactEntityNamespace,
  PrimaryContactEntityReducer,
} from './primary-contact.store';

@NgModule({
  imports: [
    StoreModule.forFeature(PrimaryContactEntityNamespace, PrimaryContactEntityReducer),
    EffectsModule.forFeature([PrimaryContactEntityEffects]),
  ],
})
export class PrimaryContactModule {}
